import type { FaireProductEntity } from "../../entity_types/product";

export const p_yut37p2xwf: FaireProductEntity = {
  token: "p_yut37p2xwf",
  type: "product",
  name: "Mullein Oil - 1oz",
  brandToken: "b_eradtetzzl",
  brandName: "Healthy Energy Amazing Life",
  imageUrl: "https://cdn.faire.com/fastly/bd36c487714eb557aef01d5d5963ad34add527ac953d91eb3e482cf945c1dcb8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c8615118940fbf36d706a9a622aeae30624627a57f066dcaabbd87d056b3160.png",
    "https://cdn.faire.com/fastly/a9bcb872800dfdad536f733442e972242f05eaedfdf350d8c96515b98cf19a7e.png",
    "https://cdn.faire.com/fastly/a726a2823f66c27bdfb92cdd0baaa2d2f6a593f234b2c416f3dab7a7ca9bee53.png",
    "https://cdn.faire.com/fastly/ee32e5bd449fd3595d36b09e85445886dbd3cd033881faa0ed1d2df14bae3c26.png",
    "https://cdn.faire.com/fastly/7e9029626deb8aac2805272cbe128eb792d407a90a6f5bb4615f5e085f38419a.png",
    "https://cdn.faire.com/fastly/39740f6592ebaabd60d0649e1ab0b5c4b1cae28829cf351549c8eec5f26d24de.png",
    "https://cdn.faire.com/fastly/a0e2146c8ed61c9cb42c71445728510a649960d56019ed18b28187eadcd30c20.png",
    "https://cdn.faire.com/fastly/83d4670783701a48c1542cbf5c7b4837af386736f04ee1d8b648a2589a300d0c.png",
    "https://cdn.faire.com/fastly/ad3910e519f5388c138f681fc7f439f1b0df822a697122e6bedae543ac52b869.png",
    "https://cdn.faire.com/fastly/2f1bef3ed40e7a0995898a44d31abed6926c6611cf3a377ef5ccff34c1d9ee03.png"
  ],
  priceDollars: 5.8,
  description: "Do you have dry or itchy ears? Mullein has been popularly used for treating stretch marks, scars and sunburn; however, it is also extremely effective as a natural ear ache remedy. Harmony’s Mullein Oil is safe for humans and pets.\n\nHarmony’s Mullein Oil is: \n\n * Soothing \n * Relaxing \n * Calming \nIngredients: Mullein Oil, Calendula Oil, Lemon oil, Vitamin E Oil & Grapeseed Oil.\n\nFor ear aches: use 2-4 drops of mullein oil in the ear canal, 2 times per day and massage in your ear sparingly. Never drop oil directly into ear.",
  tags: [],
  msrpDollars: 8.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:29.021Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
